define('app/views/gift_message_form_view',['app/setup'], function(takhfifan) {

  takhfifan.GiftMessageFormView = takhfifan.BaseView.extend({
    events: {
      "click .save-gift-data": 'saveGiftData',
      "click .close-gift-modal": 'closeGiftModal'
    },
    initialize: function() {
      Backbone.Validation.bind(this);
    },
    saveGiftData: function() {
      var modalWrapper = $(".tkh-modal");
      var data = takhfifan.Helper.serializeToObject(this);
      var _this = this;
      this.model.set(data, { validate: true });
      if(this.model.isValid()) {
        if(this.model.attributes.giftmessageDeliverMethod == "wrapping"){
          $.get("addGiftWrappingToCart",function(data,textStatus,jqXHR){
            if(jqXHR.status == 200){
              location.reload();
            }
          });
        }
        $('.hiddenGiftInput').remove();
        $('.giftTemplateHiddenInput').each(function(){
          var hiddenField = "<input class='hiddenGiftInput' type='hidden' name='" + $(this).data('name') + "' value='" + $(this).val() + "' />";
          $('#cart-form').prepend(hiddenField);
        });
        $('#tkhSenderName').val($('#tkhSenderName').val());
        takhfifan.eventHub.trigger('modal:closeModalWithContent');
        $('.tkh-gift-message').find('.gift-form-result').html('');
        var giftFormResult = "<div><span class='gift-data-title'>از طرف: </span><span class='gift-data-value'>"+ this.model.attributes.giftmessageFrom + " </span></div><div><span class='gift-data-title'>به: </span><span class='gift-data-value'> " + this.model.attributes.giftmessageTo + " </span></div><div><span class='gift-data-title'>پیغام: </span><span class='gift-data-value'> " + this.model.attributes.giftmessageMessage + "</span></div>";
        $('.tkh-gift-message').find('.gift-form-result').append(giftFormResult).show();
      }
      $('#allow_gift_messages').prop('checked', true);
    },
    closeGiftModal: function(options) {
      takhfifan.eventHub.trigger('modal:closeModalWithContent',options);
    }
  });
});

